import Colors, { blend, withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import FontSizes from '@polestar/component-warehouse-react/tokens/font-sizes/FontSizes';
import LetterSpacings from '@polestar/component-warehouse-react/tokens/letter-spacings/LetterSpacings';
import LineHeights from '@polestar/component-warehouse-react/tokens/line-heights/LineHeights';
const ButtonTheme = {
    button: {
        light: {
            primary: {
                states: {
                    enabled: {
                        backgroundColor: Colors.black,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    hover: {
                        backgroundColor: blend(Colors.black, Colors.white, Opacities.low),
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    active: {
                        backgroundColor: Colors.black,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.black, Colors.white, Opacities.medium),
                        color: withOpacity(Colors.white, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                    },
                },
            },
            secondary: {
                states: {
                    enabled: {
                        borderColor: Colors.black,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    hover: {
                        borderColor: blend(Colors.black, Colors.white, Opacities.medium),
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    active: {
                        borderColor: Colors.black,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    disabled: {
                        borderColor: blend(Colors.black, Colors.white, Opacities.medium),
                        color: blend(Colors.black, Colors.white, Opacities.medium),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: blend(Colors.black, Colors.white, Opacities.medium),
                    },
                },
            },
            destructive: {
                states: {
                    enabled: {
                        backgroundColor: Colors.error,
                        color: Colors.white,
                        iconColor: Colors.white,
                    },
                    hover: {
                        backgroundColor: blend(Colors.error, Colors.white, Opacities.low),
                        color: Colors.white,
                        iconColor: Colors.white,
                    },
                    active: {
                        backgroundColor: Colors.error,
                        color: Colors.white,
                        iconColor: Colors.white,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.error, Colors.white, Opacities.medium),
                        color: withOpacity(Colors.white, Opacities.medium),
                        iconColor: withOpacity(Colors.white, Opacities.medium),
                    },
                },
            },
            text: {
                states: {
                    enabled: {
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    hover: {
                        color: blend(Colors.black, Colors.white, Opacities.low),
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    active: {
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    disabled: {
                        color: withOpacity(Colors.black, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: withOpacity(Colors.black, Opacities.low),
                    },
                },
                sizes: {
                    medium: {
                        fontSize: { mobile: FontSizes.body },
                        letterSpacing: { mobile: LetterSpacings.small },
                        minHeight: { mobile: LineHeights.small },
                    },
                    large: {
                        fontSize: { mobile: FontSizes.large },
                        letterSpacing: { mobile: LetterSpacings.large },
                        minHeight: { mobile: LineHeights.large },
                    },
                },
            },
            internal: {
                states: {
                    enabled: {
                        backgroundColor: Colors.signalWhite,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    hover: {
                        backgroundColor: blend(Colors.signalWhite, Colors.black, Opacities.xLow),
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    active: {
                        backgroundColor: Colors.signalWhite,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.black,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.signalWhite, Colors.white, Opacities.medium),
                        color: withOpacity(Colors.black, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: withOpacity(Colors.black, Opacities.low),
                    },
                },
            },
        },
        dark: {
            primary: {
                states: {
                    enabled: {
                        backgroundColor: Colors.white,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    hover: {
                        backgroundColor: blend(Colors.white, Colors.black, Opacities.low),
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    active: {
                        backgroundColor: Colors.white,
                        color: Colors.black,
                        iconColor: Colors.accessibleSafetyOrange,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.white, Colors.black, Opacities.medium),
                        color: withOpacity(Colors.black, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                    },
                },
            },
            secondary: {
                states: {
                    enabled: {
                        borderColor: Colors.white,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    hover: {
                        borderColor: blend(Colors.white, Colors.black, Opacities.low),
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    active: {
                        borderColor: Colors.white,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    disabled: {
                        borderColor: blend(Colors.white, Colors.black, Opacities.medium),
                        color: withOpacity(Colors.white, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: withOpacity(Colors.white, Opacities.low),
                    },
                },
            },
            destructive: {
                states: {
                    enabled: {
                        backgroundColor: Colors.error,
                        color: Colors.black,
                        iconColor: Colors.black,
                    },
                    hover: {
                        backgroundColor: blend(Colors.error, Colors.black, Opacities.low),
                        color: Colors.black,
                        iconColor: Colors.black,
                    },
                    active: {
                        backgroundColor: Colors.error,
                        color: Colors.black,
                        iconColor: Colors.black,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.error, Colors.black, Opacities.medium),
                        color: withOpacity(Colors.black, Opacities.medium),
                        iconColor: withOpacity(Colors.black, Opacities.medium),
                    },
                },
            },
            text: {
                states: {
                    enabled: {
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    hover: {
                        color: blend(Colors.white, Colors.black, Opacities.xLow),
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    active: {
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    disabled: {
                        color: withOpacity(Colors.white, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: withOpacity(Colors.white, Opacities.low),
                    },
                },
            },
            internal: {
                states: {
                    enabled: {
                        backgroundColor: Colors.ironGrey,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    hover: {
                        backgroundColor: blend(Colors.ironGrey, Colors.white, Opacities.low),
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    active: {
                        backgroundColor: Colors.ironGrey,
                        color: Colors.white,
                        iconColor: Colors.accessibleSafetyOrange,
                        monochromeIconColor: Colors.white,
                    },
                    disabled: {
                        backgroundColor: blend(Colors.ironGrey, Colors.black, Opacities.xLow),
                        color: withOpacity(Colors.white, Opacities.low),
                        iconColor: withOpacity(Colors.accessibleSafetyOrange, Opacities.low),
                        monochromeIconColor: withOpacity(Colors.white, Opacities.low),
                    },
                },
            },
        },
    },
};
export default ButtonTheme;
